import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'

export default {
  install (Vue) {
    const connection = new HubConnectionBuilder()
      .withUrl('https://cc-api-service.cleverenrol.com/natfitdchub?Token=j4erert43rlufwe3kjd3js7fowqmdyf')
      .configureLogging(LogLevel.Information)
      .build();

    // use new Vue instance as an event bus
    const cidHub = new Vue();
    // every component will use this.$questionHub to access the event bus
    Vue.prototype.$cidHub = cidHub;
    // Forward server side SignalR events through $questionHub, where components will listen to them
    connection.on('NFDCEvent', (id) => {
        cidHub.$emit('cid-changed', {id});
    });
 
    let startedPromise = null;
    function start() {
      startedPromise = connection.start().catch(err => {
        console.log('Failed to connect with hub', err);
        return new Promise((resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 5000));
      });
      return startedPromise;
    }
    connection.onclose(() => start());
    start();
  },
};



// WEBPACK FOOTER //
// ./src/cid.js